import { api } from "../../shared/hooks/api";

const ACTIVE_MATERIALS_URL = `/materials?option=outsource_materials&is_active=true&page_size=${Number.MAX_SAFE_INTEGER}`;

export const useActiveMaterialsCatalog = (skip = false) => {
    const [{ data, isLoading, error }, fetchMaterials] = api.get(
        ACTIVE_MATERIALS_URL,
        undefined,
        skip,
    );

    return {
        materials: data?.results || [],
        isLoading,
        error,
        fetchMaterials,
    };
};
